module.exports = __webpack_public_path__ + "h5/img/three.2162defb.png";